"use client";

import { useTranslation } from "@guru/shared/i18n";
import { cn } from "@guru/shared/utils/cn";
import Link from "next/link";
import { PricingSection } from "@/components/public/homepage/pricing-section";
import { ScrollReveal } from "@/components/public/scroll-reveal";
import { CalculatorSection } from "./calculator-section";
import { PricingComparisonTable } from "./pricing-comparison-table";
import { PricingFAQ } from "./pricing-faq";

export function PricingPage() {
  const { t } = useTranslation();

  return (
    <div className="min-h-screen">
      {/* Hero Section */}
      <section className="py-16 bg-gradient-to-b from-background to-muted/20">
        <div className="max-w-7xl mx-auto px-4 text-center">
          <ScrollReveal>
            <h1 className={cn("text-4xl font-bold mb-4 text-foreground")}>
              {t.pricing.hero.title}
            </h1>
            <p className={cn("text-xl text-muted-foreground max-w-2xl mx-auto")}>
              {t.pricing.hero.subtitle}
            </p>
          </ScrollReveal>
        </div>
      </section>

      {/* Pricing Cards - Reuse from homepage */}
      <PricingSection />

      {/* Fee-recovery calculator — justifies the price on the visitor's own numbers */}
      <CalculatorSection />

      {/* Full Comparison Table */}
      <PricingComparisonTable />

      {/* Extended FAQ */}
      <PricingFAQ />

      {/* Refund policy cross-link — required for India e-commerce compliance */}
      <p className={cn("pb-16 text-center text-sm text-muted-foreground")}>
        Prices are in INR, inclusive of GST. See our{" "}
        <Link href="/refund-policy" className="underline underline-offset-4 hover:text-foreground">
          Refund and Cancellation Policy
        </Link>{" "}
        for billing, cancellation, and refund terms.
      </p>
    </div>
  );
}
